
import {z} from "zod";
import { ContentStatuses, UseCaseChat } from "../UseCaseChat";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { UseCaseSchema } from "./UseCase.schema";
import { ChatSchema } from "./Chat.schema";
import { UseCase } from "../UseCase";
import { Chat } from "../Chat";


const _UseCaseChatZod = z.object({
  id: z.string().default(""),
  contentStatus: z.enum(ContentStatuses).default("none"),
  useCase: UseCaseSchema.default(new UseCase()),
  chat: ChatSchema.default(new Chat())
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _UseCaseChatZod, Omit<UseCaseChat, "isSufficientForReportGeneration">>);

export const UseCaseChatSchema = _UseCaseChatZod.transform((data) => new UseCaseChat(data));


